import { Alert, Button, Typography } from "@mui/material";
import { Box, Grid } from "@mui/system";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import DoneIcon from "@mui/icons-material/Done";
import SaveChangesModal from "./SaveChangesModal/SaveChangesModal";
import React from "react";

const ManualConfigurationHead = () => {

  const [openModal, setOpenModal] = React.useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <Box sx={{ padding: "16px 16px 0px" }}>
        <Grid container spacing={2} alignItems="center" sx={{ mb: 1 }}>
          <Grid size={8}>
            <Box>
              <Typography variant="h3" sx={{ fontSize: "24px" }}>
                Awin Sport UK
                <Box component="span" sx={{ color: "#00000099", marginX: 1 }}>
                  (4567)
                </Box>
                <Alert
                  severity="success"
                  variant="outlined"
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    border: "1px solid #86b58c",
                    borderRadius: "4px",
                    backgroundColor: "#eef8ef",
                    color: "#1d4d27",
                    padding: "2px 4px",

                    "& .MuiAlert-icon": {
                      color: "#1d4d27",
                      fontSize: 15,
                      mr: 0.5,
                      padding: 0,
                      alignItems: "center",
                    },

                    "& .MuiAlert-message": {
                      fontSize: 13,
                      padding: 0,
                    },
                  }}
                  iconMapping={{
                    success: <CheckCircleOutlineIcon fontSize="inherit" />,
                  }}
                >
                  Active
                </Alert>
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ fontSize: "14px", mt: 0.5 }}>
              Interface: <span style={{ fontWeight: 500 }}>IncomeAccess</span>{" "}
              (30){" "}
              <span style={{ color: "#00000061" }}>
                - bound by the first connection
              </span>
            </Typography>
          </Grid>
          <Grid size={4} sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Box>
              <Button
                onClick={handleOpenModal}
                variant="contained"
                //disabled
                color="secondary"
                endIcon={<SaveOutlinedIcon />}
              >
                save changes
              </Button>
              <SaveChangesModal
                openModal={openModal}
                handleClose={handleCloseModal}
              />
              <Typography
                variant="body2"
                sx={{
                  fontSize: "12px",
                  mt: 0.5,
                  textAlign: "right",
                  color: "#D32F2F",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <CloseOutlinedIcon sx={{ fontSize: 14, mr: 0.5 }} />
                2/3 Steps connected
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: "12px",
                  mt: 0.5,
                  textAlign: "right",
                  color: "#2E7D32",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <DoneIcon sx={{ fontSize: 14, mr: 0.5 }} />
                3/3 Steps connected
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default ManualConfigurationHead;
